import * as Moment from 'moment';
import 'moment/locale/de';
import {extendMoment} from 'moment-range';
const moment = extendMoment(Moment);

class ScheduleHelper {
    static prepareLocationRendering(locations) {
        let location;
        let shift;
        let pipes;
        let pipe;
        for(let i = 0; i < locations.length; i++) {
            location = locations[i];
            pipes = location.pipes = [];
            pipes.push([]);
            for(let j = 0; j < location.shifts.length; j++) {
                shift = location.shifts[j];
                for(let k = 0; k < pipes.length; k++) {
                    pipe = pipes[k];
                    if(pipe.length < 1) {
                        pipe.push(shift);
                        break;
                    } else {
                        if(moment(shift.startAt).isBefore(moment(pipe[pipe.length -1].endAt))) {
                            if(k !== (pipes.length -1)) {
                                continue;
                            } else {
                                pipes.push([shift]);
                                break;
                            }
                        } else {
                            pipe.push(shift);
                            break;
                        }
                    }
                }
            }
        }
        return locations;
    }
}

export default ScheduleHelper;
